import React, { lazy } from "react";

const SendVideosPageLazy = lazy(() => import("./index"));

export const SendVideosPage = (props) => <SendVideosPageLazy {...props} />;
